'use client'

import Testimonials from '../components/CarouselBlockDisplays/Testimonial/Testimonials'
import { CarouselBlock as CarouselBlockType } from '@onclicks/payload-types'

const carousel = {
  products: null,
  brands: null,
  testimonials: Testimonials,
}

const CarouselBlock: React.FC<CarouselBlockType> = (props) => {
  const { type } = props || {}

  if (!type) return null

  const CarouselToRender = carousel[type]

  if (!CarouselToRender) return null

  return <CarouselToRender {...props} />
}

export default CarouselBlock
